module.exports = "/fonts/icomoon.ttf?8faeca7aa13e6f1176d4b1ee81387b1b";